import { Component, forwardRef, Inject, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as moment_tz from 'moment-timezone';
import { ContextService } from "../../../service/context.service";


@Component({
    selector: 'date-time-input',
    template: require('./date-time-input.component.html')
})
export class DateTimeInputComponent implements OnInit {

    @Input() timestamp: number;

    @Input() label: string;

    @Input() required: boolean;

    @Input() name: string;

    @Input() form: FormGroup;

    date: moment.Moment;
    time: string;

    private timezone: string;
    private control: FormControl;

    constructor(
        @Inject(forwardRef(() => ContextService)) private contextService: ContextService
    ) { }

    ngOnInit(): void {
        this.initDates();
        this.control = new FormControl(this.getTimestamp(), this.required ? Validators.required : null);
        this.form.setControl(this.name, this.control);
    }

    private initDates(): void {
        this.timezone = this.contextService.getTimezone();
        this.date = moment_tz.tz(this.timestamp, this.timezone);
        this.time = this.getTimeString(this.date);
    }

    private getTimeString(moment: moment.Moment): string {
        return this.formatString(moment.hours()) + ':' + this.formatString(moment.minutes());
    }

    private formatString(num: number) {
        return num.toString().length == 1 ? '0' + num : num;
    }

    private getTimestamp() {
        if (!this.date) {
            return null;
        }
        const localeDate = moment_tz.tz(this.date.format("YYYY-MM-DD"), 'YYYY-MM-DD', this.timezone);
        let hours = Number(this.time?.substring(0, 2));
        let minutes = Number(this.time?.substring(3, 5));
        let result = localeDate.set({ hour: hours, minute: minutes, second: 0, millisecond: 0 });
        return result.valueOf() > 0 ? result.valueOf() : null;
    }

    updateControl(): void {
        this.control.setValue(this.getTimestamp());
    }

}
